import { render, staticRenderFns } from "./word.vue?vue&type=template&id=1a249298&scoped=true"
import script from "./word.vue?vue&type=script&lang=js"
export * from "./word.vue?vue&type=script&lang=js"
import style0 from "./word.vue?vue&type=style&index=0&id=1a249298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a249298",
  null
  
)

export default component.exports